/* Web Push subscription helpers. */
import api from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function getPushPermission() {
  if (!pushSupported()) return "unsupported";
  return Notification.permission;
}

export async function subscribePush() {
  if (!pushSupported()) throw new Error("Push wird auf diesem Gerät nicht unterstützt.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Berechtigung verweigert.");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-key");
  if (!data?.publicKey) throw new Error("Server-Konfiguration fehlt.");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.publicKey),
  });
  const subJson = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: subJson.endpoint,
    keys: subJson.keys,
  });
  return true;
}

export async function unsubscribePush() {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    const subJson = sub.toJSON();
    try {
      await api.post("/push/unsubscribe", { endpoint: subJson.endpoint, keys: subJson.keys });
    } catch { /* ignore */ }
    await sub.unsubscribe();
  }
}

/**
 * Ensure the user has an active push subscription registered with the backend.
 * Reuses an existing browser subscription if present, otherwise prompts for permission
 * and creates a new one. Returns true on success.
 */
export async function ensurePushSubscription() {
  if (!pushSupported()) throw new Error("Push wird auf diesem Gerät nicht unterstützt.");
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (sub) {
    const subJson = sub.toJSON();
    await api.post("/push/subscribe", { endpoint: subJson.endpoint, keys: subJson.keys });
    return true;
  }
  return subscribePush();
}
